import React from 'react';

import {
  FormDataConsumer,
  required,
  TextInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

import { Grid } from '@mui/material';

import requestEntityFields from '../../../../constants/requestEntityFields';
import requestTypes from '../../../../constants/requestTypes';
import currencies from '../../../../constants/currencies';
import { transmodeTypesChoices } from '../../../../constants/transmodeTypes';
import SmartDateInput from '../../../../customFields/SmartDateInput';
import ReferenceEntityInputV2 from '../../../../customFields/ReferenceEntityInputV2';
import requestRolesChoices from '../../../../constants/requestRoles';

const CarPurchase = () => (
  <Grid container spacing={6}>
    <FormDataConsumer>
      {({ formData }) => formData.requestType && (
        <Grid
          size={{
            xs: 12,
            lg: 8,
          }}
        >
          <Grid container spacing={6}>
            <Grid size={3}>
              <TextInput source="extraInformation.amount" label="Amount" validate={required()} fullWidth />
            </Grid>
            <Grid size={3}>
              <SmartDateInput source="extraInformation.date" label="Date" validate={required()} fullWidth />
            </Grid>
            <Grid size={3}>
              <AutocompleteInput label="Currency" source="extraInformation.currency" choices={currencies.map((currency) => ({ id: currency, name: currency }))} validate={required()} fullWidth />
            </Grid>
            <Grid size={3}>
              <TextInput source="extraInformation.textMessage" label="Text message" fullWidth />
            </Grid>
            <Grid size={3}>
              <TextInput source="extraInformation.reference" label="Reference" fullWidth />
            </Grid>
            <Grid size={3}>
              <SelectInput choices={transmodeTypesChoices} source="extraInformation.transactionChannel" label="Transaction channel" fullWidth />
            </Grid>
            <Grid size={3}>
              <TextInput source="extraInformation.transactionChannelProvider" label="Transaction channel provider" fullWidth />
            </Grid>
            <Grid size={3}>
              <TextInput source="extraInformation.valuation" label="Valuation" resettable fullWidth />
            </Grid>
          </Grid>
        </Grid>
      )}
    </FormDataConsumer>
    {requestEntityFields[requestTypes.CAR_PURCHASE.id].map((role) => (
      <Grid
        display="flex"
        key={role}
        size={12}
      >
        <ReferenceEntityInputV2
          key={role}
          label={requestRolesChoices[role].name}
          source={`extraInformation.${role}`}
        />
      </Grid>
    ))}
  </Grid>
);

export default CarPurchase;
